import React from 'react'

import './writers.scss'

/**
 * A component for displaying information about a writer or blogger.
 *
 * @param {Object} props.writer - Information about the writer.
 * @param {boolean} props.isBlogger - Indicates if the writer is a blogger.
 * @returns {JSX.Element} A React component displaying writer or blogger information.
 */
export const Writer = ({ writer, isBlogger }) => {
  return (
    <div className="writer-container">
      {isBlogger && (
        <div className="is-blogg">
          <div>
            <span>B</span>
          </div>
        </div>
      )}
      <img src={writer.avatar} alt="avatar" />
      <div className="text-container">
        <p>{writer.name}</p>
        <p>{writer.title}</p>
      </div>
    </div>
  )
}
